import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { ValueContainer } from "components/shared/select";
import { dateTimeToView } from "helpers/date";
import { logistTaskStatuses } from "helpers/enums";
import { paths } from "helpers/paths";
import { DateRangeColumnFilter, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";
import { list as logistsList } from "sources/books/employees";
import { getListForSelect } from "sources/books/usersGroups";

class LogistTasks extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            {
                Header: "ID",
                accessor: "id",
                width: 100,
                filterable: true,
                filterType: "int",
                Cell: ({ value }) => <Link to={paths.tasksShow(value)}>{value}</Link>,
            },
            {
                Header: "Название",
                accessor: "name",
                sortable: false,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.tasksShow(id)}>{value}</Link>,
            },
            {
                Header: "Статус",
                accessor: "status",
                filterable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "status" },
                            options: logistTaskStatuses,
                        }}
                    />
                ),
                Cell: ({ value }) => enumLabel(logistTaskStatuses, value),
                CSVExport: ({ value }) => enumLabel(logistTaskStatuses, value),
            },
            {
                Header: "Ответственный",
                accessor: "userName",
                id: "userId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => {
                    if (!this.props.roles.isTruckingOrganizationAdmin) {
                        return null;
                    }
                    return (
                        <SelectColumnFilter
                            {...props}
                            selectProps={{
                                url: logistsList,
                                inputProps: { name: "fullNameOrEmail" },
                                propName: "fullNameOrEmail",
                                components: { ValueContainer },
                            }}
                        />
                    );
                },
            },
            {
                Header: "Группа пользователей",
                accessor: "groupName",
                id: "groupId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => {
                    if (!this.props.roles.isTruckingOrganizationAdmin) {
                        return null;
                    }
                    return (
                        <SelectColumnFilter
                            {...props}
                            selectProps={{
                                url: getListForSelect,
                                inputProps: { name: "groupId" },
                                propName: "name",
                                components: { ValueContainer },
                            }}
                        />
                    );
                },
            },
            {
                Header: "Заявка",
                accessor: "bidId",
                filterType: "int",
                filterable: true,
                Cell: ({ value }) =>
                    value && (
                        <a target="_blank" rel="noopener noreferrer" href={paths.bidShow("bid", value)}>
                            {value}
                        </a>
                    ),
            },
            {
                Header: "Дата создания",
                accessor: "createdAt",
                filterable: true,
                filterType: "dateTimeRange",
                sortable: true,
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
            {
                Header: "Дата выполнения",
                accessor: "completedAt",
                filterable: true,
                filterType: "dateTimeRange",
                sortable: true,
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
        ];
    }

    renderHead = () => {
        return (
            <div className="book-list__head-wrap">
                <div className="book-list__head">
                    <div className="book-list__head-close close close--sm" onClick={this.close} />
                    <div className="book-list__head-title">{this.props.title}</div>
                    <div className="btn-toolbar">
                        <div className="btn-group">
                            <Link className="btn px-4 btn-secondary" to={paths.tasksKanban}>
                                Канбан
                            </Link>
                            <Link className="btn px-4 btn-dark" to={paths.tasksTable}>
                                Таблица
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(LogistTasks, "tasks");
